import { BooleanCons, NumberCons, StringConst } from 'src/app/constants/const';
import { CreditValidation } from '../http/creditResponse.model';
import { InvoicesInfo } from '../http/invoices-Pending';
import { CallPlace } from '../http/myActivity.model';
import { IConfirmationRes, ResponseConfirm } from '../http/ordersresume.model';
import { PaymentCard } from '../http/profile.model';

export class ChangePayMethodStructor {
  data: ChangePayMethodData;
  callPlace: CallPlace;
  invoicesInfo?: InvoicesInfo[];
  isExpired: boolean;
  constructor() {
    this.data = new ChangePayMethodData();
    this.callPlace = CallPlace.default;
    this.invoicesInfo = [];
    this.isExpired = BooleanCons.false;
  }
}

export class PayInvoicesData {
  invoicesInfo: InvoicesInfo[];
  operation: PayInvoicesOperation;
  transactionId: string;
  totalProducts: number;
  totalPieces: number;
  constructor() {
    this.invoicesInfo = [];
    this.operation = PayInvoicesOperation.default;
    this.transactionId = StringConst.empty;
    this.totalProducts = NumberCons.zero;
    this.totalPieces = NumberCons.zero;
  }
}

export const enum PayInvoicesOperation {
  pay,
  changePayMethod,
  default,
}

export const PayInvoicesOperationCompare = {
  pay: 0,
  changePayMethod: 1,
  default: 2,
};

export class ChangePayMethodData {
  paymentData: PaymentCard[];
  totalMount: number;
  oxxoCustomerId: string;
  validInfo: string;
  customerId: string;
  transactionId: string;
  showAddPaymentCardButton: boolean;
  validCredit: CreditValidation;
  constructor() {
    this.paymentData = [];
    this.totalMount = NumberCons.zero;
    this.validInfo = StringConst.empty;
    this.customerId = StringConst.empty;
    this.transactionId = StringConst.empty;
    this.showAddPaymentCardButton = BooleanCons.false;
    this.validCredit = new CreditValidation();
    this.oxxoCustomerId = StringConst.empty;
  }
}

export class AfterChangePaymentInfo {
  type: string;
  res: ResponseConfirm;
  haveInvalidPackages: boolean;
  constructor() {
    this.type = StringConst.empty;
    this.res = new ResponseConfirm();
    this.haveInvalidPackages = BooleanCons.false;
  }
}
